import styled from "styled-components";
import {
  CARD_BACKGROUND,
  COLORS,
  FONT_SIZE,
  FONTS,
} from "../../../../constants/Styles";

export const Title = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size24};
`;

export const ErrorText = styled.div`
  color: ${COLORS.error};
  font-size: ${FONT_SIZE.size13};
`;

export const QuoteHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const QuoteHistoryItem = styled.div`
  border-radius: 1rem;
  ${CARD_BACKGROUND};
  display: flex;
  gap: 1rem;
  padding: 1rem;
  flex-wrap: wrap;
`;
